<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town</title>
<p class="ctr" id="pAV1W"><a href="#/contents#RR_12" id="CC_12"> Elinor’s Eggnog</a></p>
<p class="tx6" id="AJJY"><i> A Mayberry holiday tradition. </i></p>
<p class="tx5" id="pAdq"><b> 6 eggs </b></p>
<p class="tx5" id="AV0"><b> 1 cup milk </b></p>
<p class="tx5" id="A7C"><b> ⅔ cup sugar </b></p>
<p class="tx5" id="AMNg"><b> 1 teaspoon nutmeg </b></p>
<p class="tx5" id="pAgV"><b> ¼ teaspoon salt </b></p>
<p class="tx5" id="Aet5"><b> 1 teaspoon vanilla extract </b></p>
<p class="tx5" id="AL25"><b> 1 cup heavy whipping cream </b></p>
<p class="tx5" id="AUxG"><b> Rum or brandy, optional </b></p>
<p class="tx1" id="pAZ3"><span class="dcap">S</span>eparate eggs. Put whites in a bowl and refrigerate. In a glass bowl, beat egg yolks; then add milk, sugar, nutmeg, and salt. Mix well and microwave on high power for 3 minutes, stirring well after each minute. Chill mixture for several hours. Beat egg whites until fluffy and then gently stir them into chilled egg-milk mixture. Stir in vanilla. Whip cream until thick; then add to the rest. (When Barney’s not looking, Otis likes to add a little rum or brandy.) Serve very cold. If using a punch bowl, chill bowl in freezer beforehand.</p>
<p class="tx" id="pA4_">Makes 1 quart.</p>
<p class="txrr" id="pAeu"> <i>Cindee and Paul Mulik—Joplin, Missouri</i></p>
<div class="box" id="Af39">
<p class="tx1a" id="pA0x"><i>It’s beginning to taste a lot like Christmas:</i></p>
<table id="pAfi">
<tbody id="Afi" style="vertical-align: top;">
<tr id="tr-Afi-0">
<td id="td-Afi-0-0" style="width: 10%;"><p class="txtb">ANDY:</p></td>
<td id="td-Afi-0-1">Oh, looky at the eggnog!</td>
</tr>
<tr id="tr-Afi-1">
<td id="td-Afi-1-0"><p class="txtb">ELLIE:</p></td>
<td id="td-Afi-1-1">Try some right now.</td>
</tr>
<tr id="tr-Afi-2">
<td id="td-Afi-2-0"><p class="txtb">ANDY:</p></td>
<td id="td-Afi-2-1">All right. I’ll try a bite of that. Golly, that’s good eggnog!</td>
</tr>
</tbody>
</table></div>
<div class="image" id="pA8OJ">
<p class="ser"><img alt="images/img-15-1.jpg" id="A8OJ" src="images/img-15-1.jpg"/></p>
<p class="txcc" id="pA-u"> <i>CHRISTMAS SPIRITS—Even Scrooge couldn't resist Ellie's Eggnog during Christmastime in Mayberry.</i></p>
</div>
<div class="box" id="Abax">
<p class="tx1a" id="pAit"><i>So how does Aunt Bee’s lemonade rate with somebody who’s been watching Andy replace shingles on a hot roof all day?:</i></p>
<table>
<tbody style="vertical-align: top;">
<tr>
<td style="width: 30%;"><p class="txtb">MR. WHEELER:</p></td>
<td>Mmm, mmm, mmm! Just hits the spot!</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter12.vue?228a7013